import { PRODUCT_TYPE } from "@erp/shared/types/product.types";
export const typeList = [
    PRODUCT_TYPE.원부자재,
    PRODUCT_TYPE.반제품,
    PRODUCT_TYPE.완제품,
];
export const initialData = {
    type: PRODUCT_TYPE.원부자재,
    classificationId: null,
    classification: "",
    productCode: "",
    name: "",
    num: 0,
    spotId: null,
    spot: "",
    spec: "",
    model: "",
    manufacturerId: null,
    manufacturer: "",
    unitPrice: 0,
};
export const stockSelectChecks = [
    {
        validator: (data) => !!(data.num && data.spot && data.unitPrice),
        errorMessage: "입고수량, 입고장소, 입고단가 필수 입력",
    },
    {
        validator: (data) => {
            const numStr = String(data.num).replace(/[, \s]/g, "");
            const num = numStr === "" ? 0 : Number(numStr);
            return !isNaN(num) && num > 0;
        },
        errorMessage: "입고수량은 0보다 커야합니다.",
    },
];
export const directInputChecks = [
    {
        validator: (data) => !!(data.model || data.spec),
        errorMessage: "모델과 사양 중 하나는 꼭 기입되어야 합니다.",
    },
    {
        validator: (data) => !!data.spec,
        errorMessage: "사양은 반드시 기입되어야 합니다.",
    },
    {
        validator: (data) => {
            const { type, classification, name, num, spot, manufacturer } = data;
            return !!(type &&
                classification &&
                name &&
                num !== 0 &&
                num &&
                spot &&
                manufacturer);
        },
        errorMessage: "모델 혹은 사양 외 기본 정보를 모두 기입해주세요.",
    },
    {
        validator: (data) => {
            const num = Number(String(data.num).replace(/[, \s]/g, ""));
            return !isNaN(num) && num > 0;
        },
        errorMessage: "입고수량은 0보다 커야합니다.",
    },
];
